(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-welcome-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const managerKey = '__shopifyWelcomePopupManager';

    if (window[managerKey]) {
      window[managerKey].init(document);
      return;
    }

    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'textarea:not([disabled])',
      'input:not([disabled]):not([type="hidden"])',
      'select:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    const getCookie = (name) => {
      const encodedName = `${encodeURIComponent(name)}=`;
      const cookies = document.cookie ? document.cookie.split('; ') : [];
      const matchingCookie = cookies.find((cookie) => cookie.startsWith(encodedName));

      return matchingCookie ? decodeURIComponent(matchingCookie.slice(encodedName.length)) : null;
    };

    const setCookie = (name, value, days) => {
      const expiresAt = new Date(Date.now() + days * 86400000).toUTCString();
      const secureAttribute = window.location.protocol === 'https:' ? '; Secure' : '';

      document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; Expires=${expiresAt}; Path=/; SameSite=Lax${secureAttribute}`;
    };

    const syncScrollLock = () => {
      const hasOpenPopup = Boolean(document.querySelector('[data-welcome-popup].is-open'));
      document.documentElement.classList.toggle('welcome-popup-scroll-lock', hasOpenPopup);
    };

    const setupPopup = (root) => {
      if (root.dataset.popupInitialized === 'true') return;

      root.dataset.popupInitialized = 'true';

      if (root.dataset.enabled !== 'true') {
        root.hidden = true;
        return;
      }

      const dialog = root.querySelector('[role="dialog"]');
      const formState = root.querySelector('[data-form-state]');
      const closeTriggers = root.querySelectorAll('[data-popup-close]');
      const successful = formState?.dataset.success === 'true';
      const hasErrors = formState?.dataset.errors === 'true';
      const cookieName = root.dataset.cookieName;
      const cookieDays = Math.max(1, Number(root.dataset.cookieDays) || 1);
      const delay = Math.max(0, Number(root.dataset.delay) || 0) * 1000;
      const designMode = Boolean(window.Shopify && window.Shopify.designMode);
      let delayTimer = null;
      let hideTimer = null;
      let lastFocusedElement = null;

      const getFocusableElements = () =>
        Array.from(dialog.querySelectorAll(focusableSelector)).filter(
          (element) => !element.hasAttribute('hidden') && element.offsetParent !== null
        );

      const openPopup = (force = false) => {
        if (!force && !designMode && getCookie(cookieName)) return;

        window.clearTimeout(hideTimer);
        lastFocusedElement = document.activeElement;
        root.hidden = false;
        root.setAttribute('aria-hidden', 'false');

        window.requestAnimationFrame(() => {
          root.classList.add('is-open');
          syncScrollLock();

          const focusTarget = hasErrors
            ? root.querySelector('[data-form-errors]')
            : root.querySelector('[data-popup-email]') || root.querySelector('[data-popup-close]');

          focusTarget?.focus({ preventScroll: true });
        });
      };

      const closePopup = (rememberClose = true) => {
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden', 'true');
        syncScrollLock();

        if (rememberClose && !designMode) {
          setCookie(cookieName, 'dismissed', cookieDays);
        }

        hideTimer = window.setTimeout(() => {
          root.hidden = true;
        }, 260);

        if (lastFocusedElement instanceof HTMLElement) {
          lastFocusedElement.focus({ preventScroll: true });
        }
      };

      const handleKeydown = (event) => {
        if (!root.classList.contains('is-open')) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          closePopup(true);
          return;
        }

        if (event.key !== 'Tab') return;

        const focusableElements = getFocusableElements();
        if (!focusableElements.length) return;

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      };

      closeTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => closePopup(true));
      });

      root.addEventListener('keydown', handleKeydown);

      root._welcomePopupOpen = openPopup;
      root._welcomePopupClose = closePopup;
      root._welcomePopupCleanup = () => {
        window.clearTimeout(delayTimer);
        window.clearTimeout(hideTimer);
        root.removeEventListener('keydown', handleKeydown);
        root.classList.remove('is-open');
        syncScrollLock();
      };

      if (successful) {
        if (!designMode) setCookie(cookieName, 'subscribed', cookieDays);
        openPopup(true);
      } else if (hasErrors) {
        openPopup(true);
      } else if (designMode) {
        openPopup(true);
      } else if (!getCookie(cookieName)) {
        delayTimer = window.setTimeout(() => openPopup(false), delay);
      }
    };

    const init = (scope = document) => {
      if (scope.matches?.('[data-welcome-popup]')) setupPopup(scope);
      scope.querySelectorAll?.('[data-welcome-popup]').forEach(setupPopup);
    };

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });

    document.addEventListener('shopify:section:select', (event) => {
      const popup = event.target.querySelector('[data-welcome-popup]');
      popup?._welcomePopupOpen?.(true);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const popup = event.target.querySelector('[data-welcome-popup]');
      popup?._welcomePopupCleanup?.();
    });

    window[managerKey] = { init };
    init(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rosemary-customer-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rosemary-customer-videos')) {
    customElements.define('rosemary-customer-videos', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.track = this.querySelector('[data-rcv-track]');
        if (!this.track || !this.track.children.length) return;

        this.previousButton = this.querySelector('[data-rcv-previous]');
        this.nextButton = this.querySelector('[data-rcv-next]');
        this.dots = this.querySelector('[data-rcv-dots]');
        this.cards = [...this.track.children];
        this.rootDirection = document.documentElement.dir;
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.initDots();
        this.bindEvents();
        this.pauseOtherVideos();
        window.requestAnimationFrame(() => this.updateControls());
      }

      disconnectedCallback() {
        if (this.resizeHandler) window.removeEventListener('resize', this.resizeHandler);
      }

      position() {
        return this.rootDirection === 'rtl' ? Math.abs(this.track.scrollLeft) : this.track.scrollLeft;
      }

      cardStep() {
        const firstCard = this.track.firstElementChild;
        const gap = Number.parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
        return firstCard ? firstCard.getBoundingClientRect().width + gap : 280;
      }

      activeIndex() {
        return Math.max(0, Math.min(this.cards.length - 1, Math.round(this.position() / this.cardStep())));
      }

      scrollByCard(direction) {
        this.track.scrollBy({
          left: this.cardStep() * direction,
          behavior: this.prefersReducedMotion ? 'auto' : 'smooth'
        });
      }

      updateControls() {
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const current = this.position();
        if (this.previousButton) this.previousButton.disabled = current <= 2;
        if (this.nextButton) this.nextButton.disabled = current >= maximum - 2;

        this.dots?.querySelectorAll('button').forEach((dot, index) => {
          const active = index === this.activeIndex();
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      initDots() {
        if (!this.dots) return;
        this.dots.replaceChildren();
        this.cards.forEach((card, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', `${this.dataset.slideLabel || ''} ${index + 1}`.trim());
          dot.addEventListener('click', () => card.scrollIntoView({
            behavior: this.prefersReducedMotion ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'start'
          }));
          this.dots.append(dot);
        });
      }

      bindEvents() {
        this.previousButton?.addEventListener('click', () => this.scrollByCard(this.rootDirection === 'rtl' ? 1 : -1));
        this.nextButton?.addEventListener('click', () => this.scrollByCard(this.rootDirection === 'rtl' ? -1 : 1));
        this.track.addEventListener('scroll', () => this.updateControls(), { passive: true });
        this.resizeHandler = () => this.updateControls();
        window.addEventListener('resize', this.resizeHandler, { passive: true });
      }

      pauseOtherVideos() {
        const videos = [...this.querySelectorAll('video')];
        videos.forEach((video) => {
          video.addEventListener('play', () => {
            videos.forEach((otherVideo) => {
              if (otherVideo !== video) otherVideo.pause();
            });
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rosemary-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rosemary-product-recommendations')) {
    customElements.define('rosemary-product-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        if (this.dataset.loaded === 'true') {
          this.showRecommendations();
          return;
        }

        if (!this.dataset.url) return;

        fetch(this.dataset.url)
          .then((response) => response.ok ? response.text() : Promise.reject(response))
          .then((html) => {
            const documentFragment = new DOMParser().parseFromString(html, 'text/html');
            const source = documentFragment.querySelector(
              `rosemary-product-recommendations[data-section-id="${CSS.escape(this.dataset.sectionId)}"]`
            );

            if (!source || !source.querySelector('[data-rrecommend-track]')) return;

            this.innerHTML = source.innerHTML;
            this.dataset.loaded = 'true';
            this.showRecommendations();
          })
          .catch(() => {});
      }

      disconnectedCallback() {
        window.clearInterval(this.autoplayTimer);
        if (this.resizeHandler) window.removeEventListener('resize', this.resizeHandler);
      }

      showRecommendations() {
        this.track = this.querySelector('[data-rrecommend-track]');
        if (!this.track || !this.track.children.length) return;

        this.hidden = false;
        this.initSlider();
        this.initActions();
        window.requestAnimationFrame(() => this.classList.add('is-visible'));
      }

      initActions() {
        if (this.dataset.actionsReady === 'true') return;
        this.dataset.actionsReady = 'true';

        this.addEventListener('click', async (event) => {
          const button = event.target.closest('[data-rrecommend-add], [data-rrecommend-buy]');
          if (!button || !this.contains(button)) return;

          const variantId = Number(button.dataset.variantId);
          const actions = button.closest('.r-product__actions');
          const status = actions?.querySelector('[data-rrecommend-status]');
          const actionButtons = actions?.querySelectorAll('button') || [];
          const goToCheckout = button.matches('[data-rrecommend-buy]');
          let navigatingToCheckout = false;
          if (!variantId) return;

          actionButtons.forEach((item) => { item.disabled = true; });
          if (status) {
            status.classList.remove('is-error');
            status.textContent = 'جاري الإضافة…';
          }

          try {
            if (!window.RosemaryCart?.addItems) throw new Error('تعذر تهيئة السلة');
            await window.RosemaryCart.addItems([{ id: variantId, quantity: 1 }], {
              openDrawer: !goToCheckout,
              trigger: button
            });

            if (status) status.textContent = 'تمت إضافة المنتج للسلة ✓';
            if (goToCheckout) {
              navigatingToCheckout = true;
              window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
            }
          } catch (error) {
            if (status) {
              status.classList.add('is-error');
              status.textContent = error.message || 'تعذر إضافة المنتج';
            }
          } finally {
            if (!navigatingToCheckout) {
              window.setTimeout(() => {
                actionButtons.forEach((item) => { item.disabled = false; });
                if (status) status.textContent = '';
              }, 1500);
            }
          }
        });
      }

      initSlider() {
        const previousButton = this.querySelector('[data-rrecommend-prev]');
        const nextButton = this.querySelector('[data-rrecommend-next]');
        const dots = this.querySelector('[data-rrecommend-dots]');
        const cards = [...this.track.children];
        const root = document.documentElement;
        const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const position = () => root.dir === 'rtl' ? Math.abs(this.track.scrollLeft) : this.track.scrollLeft;
        const cardStep = () => {
          const firstCard = this.track.firstElementChild;
          const gap = Number.parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
          return firstCard ? firstCard.getBoundingClientRect().width + gap : 280;
        };
        const activeIndex = () => Math.max(0, Math.min(cards.length - 1, Math.round(position() / cardStep())));

        const update = () => {
          const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          const currentPosition = position();
          if (previousButton) previousButton.disabled = currentPosition <= 2;
          if (nextButton) nextButton.disabled = currentPosition >= maximum - 2;
          dots?.querySelectorAll('button').forEach((dot, index) => {
            const active = index === activeIndex();
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-current', active ? 'true' : 'false');
          });
        };

        const scrollByCard = (direction) => {
          this.track.scrollBy({
            left: cardStep() * direction,
            behavior: prefersReduced ? 'auto' : 'smooth'
          });
        };

        previousButton?.addEventListener('click', () => scrollByCard(root.dir === 'rtl' ? 1 : -1));
        nextButton?.addEventListener('click', () => scrollByCard(root.dir === 'rtl' ? -1 : 1));
        this.track.addEventListener('scroll', update, { passive: true });

        if (dots) {
          dots.replaceChildren();
          cards.forEach((card, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.setAttribute('aria-label', `${this.dataset.slideLabel || ''} ${index + 1}`.trim());
            dot.addEventListener('click', () => card.scrollIntoView({
              behavior: prefersReduced ? 'auto' : 'smooth',
              block: 'nearest',
              inline: 'start'
            }));
            dots.append(dot);
          });
        }

        this.resizeHandler = update;
        window.addEventListener('resize', this.resizeHandler, { passive: true });
        window.requestAnimationFrame(update);

        if (this.dataset.autoplay === 'true' && cards.length > 1 && !prefersReduced) {
          const speed = Math.max(2, Number(this.dataset.autoplaySpeed || 5)) * 1000;
          const startAutoplay = () => {
            window.clearInterval(this.autoplayTimer);
            this.autoplayTimer = window.setInterval(() => {
              const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
              if (position() >= maximum - 2) {
                cards[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
              } else {
                scrollByCard(root.dir === 'rtl' ? -1 : 1);
              }
            }, speed);
          };
          const stopAutoplay = () => window.clearInterval(this.autoplayTimer);

          this.addEventListener('pointerenter', stopAutoplay);
          this.addEventListener('pointerleave', startAutoplay);
          this.addEventListener('focusin', stopAutoplay);
          this.addEventListener('focusout', startAutoplay);
          startAutoplay();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rosemary-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rosemary-recently-viewed')) {
    customElements.define('rosemary-recently-viewed', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        const currentScript = this.querySelector('[data-rrecent-current]');
        this.track = this.querySelector('[data-rrecent-list]');
        if (!currentScript || !this.track) return;

        let current;
        try {
          current = JSON.parse(currentScript.textContent);
        } catch (error) {
          return;
        }

        const storedItems = this.readItems();
        const limit = Math.max(1, Number(this.dataset.limit || 3));
        const recentItems = storedItems
          .filter((item) => item && item.handle && item.handle !== current.handle)
          .slice(0, limit);

        if (recentItems.length) {
          this.track.innerHTML = recentItems.map((item) => this.renderCard(item)).join('');
          this.hidden = false;
          this.initActions();
          this.initSlider();
          window.requestAnimationFrame(() => this.classList.add('is-visible'));
        } else if (this.dataset.designMode === 'true') {
          this.hidden = false;
          this.initSlider();
          window.requestAnimationFrame(() => this.classList.add('is-visible'));
        }

        this.storeCurrent(storedItems, current);
      }

      disconnectedCallback() {
        window.clearInterval(this.autoplayTimer);
        if (this.resizeHandler) window.removeEventListener('resize', this.resizeHandler);
      }

      readItems() {
        try {
          const items = JSON.parse(localStorage.getItem('recently-viewed-products') || '[]');
          return Array.isArray(items) ? items : [];
        } catch (error) {
          return [];
        }
      }

      storeCurrent(items, current) {
        if (!current?.handle) return;

        try {
          const nextItems = [
            current,
            ...items.filter((item) => item && item.handle !== current.handle)
          ].slice(0, 12);
          localStorage.setItem('recently-viewed-products', JSON.stringify(nextItems));
        } catch (error) {
          return;
        }
      }

      initSlider() {
        const previousButton = this.querySelector('[data-rrecent-prev]');
        const nextButton = this.querySelector('[data-rrecent-next]');
        const dots = this.querySelector('[data-rrecent-dots]');
        const cards = [...this.track.children];
        const root = document.documentElement;
        const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const position = () => root.dir === 'rtl' ? Math.abs(this.track.scrollLeft) : this.track.scrollLeft;
        const cardStep = () => {
          const firstCard = this.track.firstElementChild;
          const gap = Number.parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
          return firstCard ? firstCard.getBoundingClientRect().width + gap : 280;
        };
        const activeIndex = () => Math.max(0, Math.min(cards.length - 1, Math.round(position() / cardStep())));

        const update = () => {
          const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          const currentPosition = position();
          if (previousButton) previousButton.disabled = currentPosition <= 2;
          if (nextButton) nextButton.disabled = currentPosition >= maximum - 2;
          dots?.querySelectorAll('button').forEach((dot, index) => {
            const active = index === activeIndex();
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-current', active ? 'true' : 'false');
          });
        };

        const scrollByCard = (direction) => {
          this.track.scrollBy({
            left: cardStep() * direction,
            behavior: prefersReduced ? 'auto' : 'smooth'
          });
        };

        previousButton?.addEventListener('click', () => scrollByCard(root.dir === 'rtl' ? 1 : -1));
        nextButton?.addEventListener('click', () => scrollByCard(root.dir === 'rtl' ? -1 : 1));
        this.track.addEventListener('scroll', update, { passive: true });

        if (dots) {
          dots.replaceChildren();
          cards.forEach((card, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.setAttribute('aria-label', `${this.dataset.slideLabel || ''} ${index + 1}`.trim());
            dot.addEventListener('click', () => card.scrollIntoView({
              behavior: prefersReduced ? 'auto' : 'smooth',
              block: 'nearest',
              inline: 'start'
            }));
            dots.append(dot);
          });
        }

        this.resizeHandler = update;
        window.addEventListener('resize', this.resizeHandler, { passive: true });
        window.requestAnimationFrame(update);

        if (this.dataset.autoplay === 'true' && cards.length > 1 && !prefersReduced) {
          const speed = Math.max(2, Number(this.dataset.autoplaySpeed || 5)) * 1000;
          const startAutoplay = () => {
            window.clearInterval(this.autoplayTimer);
            this.autoplayTimer = window.setInterval(() => {
              const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
              if (position() >= maximum - 2) {
                this.track.scrollTo({ left: 0, behavior: 'smooth' });
              } else {
                scrollByCard(root.dir === 'rtl' ? -1 : 1);
              }
            }, speed);
          };
          const stopAutoplay = () => window.clearInterval(this.autoplayTimer);

          this.addEventListener('pointerenter', stopAutoplay);
          this.addEventListener('pointerleave', startAutoplay);
          this.addEventListener('focusin', stopAutoplay);
          this.addEventListener('focusout', startAutoplay);
          startAutoplay();
        }
      }

      renderCard(item) {
        const url = this.safeUrl(item.url);
        const image = this.safeImage(item.image);
        const showVendor = this.dataset.showVendor === 'true' && item.vendor;
        const showPrice = this.dataset.showPrice === 'true' && item.price;
        const soldOut = item.available === false && this.dataset.soldOutLabel;
        const showActions = this.dataset.showActions === 'true';
        const canQuickAdd = item.available !== false && item.variantId && item.quickAddAllowed === true;
        let actions = '';

        if (showActions) {
          if (item.available === false) {
            actions = `<button class="rrecent__action rrecent__action--disabled" type="button" disabled>${this.escapeHtml(this.dataset.soldOutLabel)}</button>`;
          } else if (canQuickAdd) {
            actions = `
              <button class="rrecent__action rrecent__action--add" type="button" data-rrecent-add data-variant-id="${this.escapeHtml(item.variantId)}">${this.escapeHtml(this.dataset.addLabel)}</button>
              <button class="rrecent__action rrecent__action--buy" type="button" data-rrecent-buy data-variant-id="${this.escapeHtml(item.variantId)}">${this.escapeHtml(this.dataset.buyLabel)}</button>
            `;
          } else {
            actions = `
              <a class="rrecent__action rrecent__action--add" href="${this.escapeHtml(url)}">${this.escapeHtml(this.dataset.chooseLabel)}</a>
              <a class="rrecent__action rrecent__action--buy" href="${this.escapeHtml(url)}">${this.escapeHtml(this.dataset.buyLabel)}</a>
            `;
          }

          actions = `<div class="rrecent__actions">${actions}<p class="rrecent__status" data-rrecent-status role="status" aria-live="polite"></p></div>`;
        }

        return `
          <article class="r-product rrecent__card">
            <div class="r-product__media-wrap">
              ${soldOut ? `<span class="r-product__badge">${this.escapeHtml(this.dataset.soldOutLabel)}</span>` : ''}
              <a class="r-product__media" href="${this.escapeHtml(url)}">
                ${image ? `<img src="${this.escapeHtml(image)}" alt="${this.escapeHtml(item.title)}" loading="lazy" width="760" height="950">` : ''}
              </a>
            </div>
            <div class="r-product__info">
              <div class="r-product__content">
                ${showVendor ? `<p class="r-product__vendor">${this.escapeHtml(item.vendor)}</p>` : ''}
                <h3><a href="${this.escapeHtml(url)}">${this.escapeHtml(item.title)}</a></h3>
                ${showPrice ? `<div class="r-product__price">${this.escapeHtml(item.price)}</div>` : ''}
              </div>
              ${actions}
            </div>
          </article>
        `;
      }

      initActions() {
        if (this.dataset.actionsReady === 'true') return;
        this.dataset.actionsReady = 'true';

        this.addEventListener('click', async (event) => {
          const button = event.target.closest('[data-rrecent-add], [data-rrecent-buy]');
          if (!button || !this.contains(button)) return;

          const variantId = Number(button.dataset.variantId);
          const actions = button.closest('.rrecent__actions');
          const status = actions?.querySelector('[data-rrecent-status]');
          const actionButtons = actions?.querySelectorAll('button') || [];
          const goToCheckout = button.matches('[data-rrecent-buy]');
          let navigatingToCheckout = false;
          if (!variantId) return;

          actionButtons.forEach((item) => { item.disabled = true; });
          if (status) {
            status.classList.remove('is-error');
            status.textContent = 'جاري الإضافة…';
          }

          try {
            if (!window.RosemaryCart?.addItems) throw new Error('تعذر تهيئة السلة');
            await window.RosemaryCart.addItems([{ id: variantId, quantity: 1 }], {
              openDrawer: !goToCheckout,
              trigger: button
            });

            if (status) status.textContent = 'تمت إضافة المنتج للسلة ✓';
            if (goToCheckout) {
              navigatingToCheckout = true;
              window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
            }
          } catch (error) {
            if (status) {
              status.classList.add('is-error');
              status.textContent = error.message || 'تعذر إضافة المنتج';
            }
          } finally {
            if (!navigatingToCheckout) {
              window.setTimeout(() => {
                actionButtons.forEach((item) => { item.disabled = false; });
                if (status) status.textContent = '';
              }, 1500);
            }
          }
        });
      }

      safeUrl(value) {
        try {
          const url = new URL(String(value || ''), window.location.origin);
          if (url.origin !== window.location.origin) return '#';
          return `${url.pathname}${url.search}${url.hash}`;
        } catch (error) {
          return '#';
        }
      }

      safeImage(value) {
        try {
          const url = new URL(String(value || ''), window.location.origin);
          return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
        } catch (error) {
          return '';
        }
      }

      escapeHtml(value) {
        return String(value || '').replace(/[&<>"']/g, (character) => ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;'
        })[character]);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rosemary-tint-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = (cents, format) => {
      const value = Number(cents || 0) / 100;
      const moneyFormat = format || '__amount__';
      const decimal = value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const whole = Math.round(value).toLocaleString('en-US');
      const decimalComma = decimal.replace(/,/g, '_').replace('.', ',').replace(/_/g, '.');
      const wholeSpace = whole.replace(/,/g, ' ');
      return moneyFormat
        .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, wholeSpace)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, whole.replace(/,/g, '.'))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, decimalComma)
        .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, decimal.replace(/,/g, "'"))
        .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, decimal.replace(/,/g, ' '))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
        .replace(/\{\{\s*amount\s*\}\}/g, decimal)
        .replace('__amount__', decimal);
    };

    const scrollToTarget = (link) => {
      const selector = link.getAttribute('href');
      if (!selector || !selector.startsWith('#')) return false;
      const target = document.querySelector(selector);
      if (!target) return false;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      return true;
    };

    const updateTotal = (root) => {
      const select = root.querySelector('[data-rc-tint-variant]');
      const quantity = Math.max(1, Number(root.querySelector('[data-rc-tint-quantity]')?.value || 1));
      const unitPrice = Number(select?.selectedOptions?.[0]?.dataset.priceCents || root.querySelector('[name="id"]')?.dataset.priceCents || root.dataset.initialPrice || 0);
      const formatted = formatMoney(unitPrice * quantity, root.dataset.moneyFormat);
      const total = root.querySelector('[data-rc-tint-total]');
      const stickyPrice = root.querySelector('[data-rc-tint-sticky-price]');
      const checkout = root.querySelector('[data-rc-tint-checkout]');
      if (total) total.textContent = formatted;
      if (stickyPrice) stickyPrice.textContent = formatted;
      if (checkout && checkout.dataset.showTotal === 'true' && !checkout.disabled && checkout.getAttribute('aria-busy') !== 'true') {
        checkout.textContent = `${checkout.dataset.defaultText} — ${formatted}`;
      }
    };

    const updateVariant = (root, select) => {
      const option = select?.selectedOptions?.[0];
      if (!option) {
        updateTotal(root);
        return;
      }
      const price = root.querySelector('[data-rc-tint-price]');
      const compare = root.querySelector('[data-rc-tint-compare]');
      const discount = root.querySelector('[data-rc-tint-discount]');
      const checkout = root.querySelector('[data-rc-tint-checkout]');
      const image = root.querySelector('.rc-tint-landing__purchase-image');
      const available = option.dataset.available === 'true';

      if (price) price.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
      if (discount) {
        const value = Number(option.dataset.discount || 0);
        discount.textContent = value > 0 ? `${discount.dataset.label || ''} ${value}%` : '';
        discount.hidden = value <= 0;
      }
      if (checkout) {
        checkout.disabled = !available;
        checkout.textContent = available ? checkout.dataset.defaultText : checkout.dataset.soldOutText;
      }
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
      }
      root.querySelectorAll('[data-rc-tint-variant-button]').forEach((button) => {
        const isSelected = button.dataset.variantId === option.value;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', String(isSelected));
      });
      updateTotal(root);
    };

    const initPurchase = (root) => {
      if (!root || root.dataset.rcTintPurchaseReady === 'true') return;
      root.dataset.rcTintPurchaseReady = 'true';
      const form = root.querySelector('[data-rc-tint-product-form]');
      const select = root.querySelector('[data-rc-tint-variant]');
      const quantity = root.querySelector('[data-rc-tint-quantity]');
      const checkout = root.querySelector('[data-rc-tint-checkout]');
      const status = root.querySelector('[data-rc-tint-status]');

      select?.addEventListener('change', () => updateVariant(root, select));
      root.querySelectorAll('[data-rc-tint-variant-button]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!select || button.disabled) return;
          select.value = button.dataset.variantId;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      root.querySelector('[data-rc-tint-qty-minus]')?.addEventListener('click', () => {
        if (quantity) {
          quantity.value = String(Math.max(1, Number(quantity.value || 1) - 1));
          updateTotal(root);
        }
      });
      root.querySelector('[data-rc-tint-qty-plus]')?.addEventListener('click', () => {
        if (quantity) {
          quantity.value = String(Math.max(1, Number(quantity.value || 1) + 1));
          updateTotal(root);
        }
      });
      quantity?.addEventListener('change', () => {
        quantity.value = String(Math.max(1, Number(quantity.value || 1)));
        updateTotal(root);
      });

      form?.addEventListener('submit', async (event) => {
        if (!window.fetch || !checkout || checkout.disabled) return;
        event.preventDefault();
        checkout.setAttribute('aria-busy', 'true');
        checkout.textContent = checkout.dataset.loadingText || checkout.dataset.defaultText;
        if (status) status.hidden = true;

        try {
          const data = new FormData(form);
          data.delete('return_to');
          const rootPath = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: data
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || checkout.dataset.errorText);
          window.location.assign(`${rootPath}checkout`);
        } catch (error) {
          checkout.removeAttribute('aria-busy');
          updateTotal(root);
          if (status) {
            status.textContent = error.message || checkout.dataset.errorText;
            status.hidden = false;
          }
        }
      });

      updateVariant(root, select);
    };

    document.querySelectorAll('.rc-tint-landing').forEach(initPurchase);

    document.addEventListener('click', (event) => {
      const link = event.target.closest('.rc-tint-landing [data-rc-tint-shades-scroll], .rc-tint-landing [data-rc-tint-purchase-scroll]');
      if (link) {
        const root = link.closest('.rc-tint-landing');
        const shade = link.dataset.rcTintShade?.toLowerCase();
        const select = root?.querySelector('[data-rc-tint-variant]');
        if (shade && select) {
          const option = Array.from(select.options).find((item) => !item.disabled && item.dataset.title?.toLowerCase().includes(shade));
          if (option) {
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        if (scrollToTarget(link)) event.preventDefault();
      }

      const stickyCheckout = event.target.closest('.rc-tint-landing [data-rc-tint-sticky-checkout]');
      if (stickyCheckout) {
        const root = stickyCheckout.closest('.rc-tint-landing');
        root?.querySelector('[data-rc-tint-product-form]')?.requestSubmit(root.querySelector('[data-rc-tint-checkout]'));
      }
    });

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('.rc-tint-landing').forEach(initPurchase);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
